import { cn } from '@/lib/utils';

type Props = {
  size?: number;
  variant?: 'mark' | 'wordmark';
  className?: string;
};

/**
 * Assets oficiais da T-Systems, copiados verbatim de
 * `aida/docs/identidade/` para `apps/web/public/assets/`.
 *
 * Não redesenhe o path: o arquivo é a fonte da verdade da identidade.
 *   - `t-systems-t.svg` → "T" isolado, viewBox 238.12×283.46
 *   - `t-systems.svg`   → wordmark horizontal "T-Systems", 1530.99×314.14
 */
const T_MARK = '/assets/t-systems-t.svg';
const WORDMARK = '/assets/t-systems.svg';

export function TSystemsMark({ size = 24, variant = 'mark', className }: Props) {
  if (variant === 'wordmark') {
    return (
      <img
        src={WORDMARK}
        width={Math.round(size * 4.87)}
        height={size}
        alt="T-Systems"
        className={cn('inline-block align-middle', className)}
      />
    );
  }
  return (
    <img
      src={T_MARK}
      width={Math.round(size * 0.84)}
      height={size}
      alt="T-Systems"
      className={cn('inline-block align-middle', className)}
    />
  );
}

type OrbProps = {
  size?: number;
  className?: string;
};

/**
 * "T-Orb" — círculo magenta com o T **original** da T-Systems centralizado.
 * A forma circular é CSS; o símbolo vem do asset oficial.
 */
export function TOrb({ size = 56, className }: OrbProps) {
  return (
    <div
      style={{ width: size, height: size }}
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-brand-500 shadow-md shadow-brand-500/30 ring-4 ring-white/70',
        className,
      )}
      aria-hidden="true"
    >
      <img
        src={T_MARK}
        alt=""
        width={Math.round(size * 0.42)}
        height={Math.round(size * 0.5)}
        className="brightness-0 invert"
      />
    </div>
  );
}